export const authActionTypes = {
  Login: 'Auth/Login',
  Logout: 'Auth/Logout',
  SetUser: 'Auth/Set User',
  SetAccessToken: 'Auth/Set Access token',
  SetWalletLimit: 'Auth/Set wallet limit',
  SetProductsInCart: 'Auth/Set products in cart'
};
